<div class="dropdown" *ngIf="displaydropdown" dropdown [dropdownToggle]="false">
  <button class="btn btn-primary dropdown-button" dropdown-open><span class="fa fa-bars"></span></button>
  <ul class="dropdown-menu">
    <li (click)="getTicketHistory()"><a>{{'ticket.REPLY'|translate | translateKey}}
        <span class="">
          <i class="fa fa-mail-reply pull-right"></i>
        </span>
      </a></li>
      <li (click)="openSpamTicketConfirmationPopup()">
        <a>{{'ticket.MARK AS SPAM'|translate | translateKey}}</a>
      </li>
      <li (click)="openAddNoteConfirmationPopup()">
        <a>{{'ticket.ADD NOTE'|translate | translateKey}}</a>
      </li>
    <!-- <li><a>PRINT
        <span class="">
          <i class="fa fa-print pull-right"></i>
        </span>
      </a>
    </li> -->
  </ul>
</div>

<div>
  <deletemodal id="customer-tab" [deleteModal]="permissionModal"></deletemodal>
  <modal #forwardEmail class="draft-email__modal modalwidth" (onOpen)="onForwardPopupOpen()" (onClose)="actionOnClose()" >
    <modal-header>
      <div class="color-blue bold">REPLY</div>
    </modal-header>
    <modal-content>
      <div *ngIf="distributorInfo" class="distributorInfo">
        <div>
          <span class="header-font bold">{{distributorInfo | displayNameFormat}} 
          </span>
        </div>
        <div *ngIf="distributorInfo.displayName && distributorInfo.memberTypeId === memberTypeEnum.DISTRIBUTOR" class="bold">
          <span>{{distributorInfo.displayName | titlecase}}</span>
        </div>
        <div *ngIf="distributorInfo">
          <a  *ngIf="(distributorInfo?.fboId || distributorInfo?.distributorId)"><i class="fa fa-copy" [copyToClipboard]="(distributorInfo?.fboId || distributorInfo?.distributorId)"></i></a> 
          <span *ngIf="distributorInfo.fboId">{{distributorInfo.fboId |distributorIdFormat}} </span>
          <span *ngIf="!distributorInfo.fboId">{{distributorInfo.distributorId |distributorIdFormat}} </span>
          <span *ngIf="distributorInfo.level ||distributorInfo.memberType"> | </span>
          <span>{{distributorInfo.level?distributorInfo.level:distributorInfo.memberType | titlecase}}</span>
        </div>
      </div>
      <div class="modalcontent-section forwardEmailTicket" *ngIf="draftEmailTicketForm">
        <form [formGroup]="draftEmailTicketForm" (ngSubmit)="onSubmit(draftEmailTicketForm.valid, draftEmailTicketForm.value)">
          <div class="col-md-12 mt-50">
            <span class="col-md-1 fw-600 mt-7 pt-7">To</span>
            <div class="col-md-11 floatLabelContainer p-l-0">
              <tag-input name="toAddress" [formControlName]="'toAddress'" (onTextChange)="onTagsChange($event)" [errorMessages]="errorMessages"
                [validators]="emailValidators" [editable]='true' [separatorKeyCodes]="[32,188,186,13]"
                [placeholder]="'Add email'" [secondaryPlaceholder]="'Enter email address(es)'"
                [addOnPaste]="true" [addOnBlur]="true" [pasteSplitPattern]="splitPattern" theme='bootstrap'>
              </tag-input>
              <div class="alert-msg"
                *ngIf="showToAddressValidation && !draftEmailTicketForm.controls['toAddress'].valid && draftEmailTicketForm.controls['toAddress'].hasError('required')&&(draftEmailTicketForm.controls['toAddress'].touched || isSubmitted)">
                {{'customer-service.To is Mandatory' |translate |translateKey}}
              </div>             
            </div>
          </div>

          <div class="col-md-12 mt-10">
            <span class="col-md-1 fw-600 mt-7 pt-7">CC</span>
            <div class="col-md-11 floatLabelContainer p-l-0">
              <tag-input name="ccAddress" [formControlName]="'ccAddress'" [errorMessages]="errorMessages"
                [validators]="emailValidators" [editable]='true' [separatorKeyCodes]="[32,188,186,13]"
                [placeholder]="'Add email'" [secondaryPlaceholder]="'Enter email address(es)'" [clearOnBlur]="false"
                [addOnPaste]="true" [addOnBlur]="true" [pasteSplitPattern]="splitPattern" theme='bootstrap'>
              </tag-input>             
              <div class="alert-msg"
                *ngIf="!draftEmailTicketForm.controls['ccAddress'].valid && draftEmailTicketForm.controls['ccAddress'].hasError('emailValidationRuleForTicket') && !draftEmailTicketForm.controls['ccAddress'].hasError('required') &&(draftEmailTicketForm.controls['ccAddress'].touched|| isSubmitted)">
                {{'customer-service.Enter valid Email'|translate | translateKey}}
              </div>
            </div>
          </div>
          <div class="col-md-12 mt-10">
            <span class="col-md-1 fw-600 mt-7 pt-7">BCC</span>
            <div class="col-md-11 floatLabelContainer p-l-0">
              <tag-input name="bccAddress" [formControlName]="'bccAddress'" [errorMessages]="errorMessages"
                [validators]="emailValidators" [editable]='true' [separatorKeyCodes]="[32,188,186,13]"
                [placeholder]="'Add email'" [secondaryPlaceholder]="'Enter email address(es)'" [clearOnBlur]="true"
                [addOnPaste]="true" [addOnBlur]="true" [pasteSplitPattern]="splitPattern" theme='bootstrap'>
              </tag-input>            
            </div>
          </div>
          <div class="col-md-12 mt-10">
            <span class="col-md-1 fw-600 mt-7 pt-7">Subject</span>
            <div class="col-md-11 email__subject floatLabelContainer p-l-0">
              <input float-label type="text" formControlName="subject" value="" class="" />
              <div class="alert-msg" *ngIf="!draftEmailTicketForm.controls['subject'].valid && draftEmailTicketForm.controls['subject'].hasError('maxlength') &&  (draftEmailTicketForm.controls['subject'].touched || isSubmitted)">
                {{'validation-message.Maximum length should be ||maxLength|| characters.' |translate | translateKey:subjectMaxLength}}
            </div>
            </div>
          </div>
          <div class="col-md-12 mt-10 ck-editorstyle ml-31" id="ckeditor-js">
            <ckeditor [editor]="_editor" [config]="_config" [data]="bodyStr">
            </ckeditor>
          </div>
           <div class="row-sameheight-block">
                <div class="col-xs-12 col-md-5 pt-20 column-equal ng-star-inserted">
                    <table class="table table-striped custab">
                        <thead>
                            <tr>
                                <th>{{'ticketing-system.File Name' |translate | translateKey}}&nbsp;</th>
                    
                                <th>{{'ticketing-system.Action' |translate | translateKey}}&nbsp;</th>
                            </tr>
                        </thead>
                        <tbody *ngIf="uploader?.queue?.length">
                            <tr *ngFor="let item of uploader.queue">
                                <td class="draft-attach">{{ item?.file?.name }}</td>
                                <td class="options">
                                  <i class="line-height1-2 fa fa-trash" (click)="item.remove();attachmentsLength= attachmentsLength-1;" (click)="removeSize()"title="{{'ticketing-system.Delete'|translate | translateKey}}"></i>
                                 </td>
                            </tr>
                        </tbody>
                        <tbody >
                          <tr><td  colspan="2">{{'ticketing-system.Max 5 attachments allowed' |translate | translateKey}}</td> 
                          </tr>
                       </tbody>
                    </table>
                </div>
                 <div class="col-xs-12 col-md-3 pad-top-10 column-equal">  
                  <div *ngIf="showMaxFileSizeValidation">
                       <span class="mar-left10 validation-msg">File Size exceeds {{draftemailattachmentMaxSize}} MB size</span>
                  </div>          
                   <label  *ngIf="!(attachmentsLength>= 5)" tabindex="0" (keyup.enter)="fileSelect.click()" for="attachFile" class="mar-left10 line-height2 btn btn-xs browse-btn  bottom-25"
                            title="{{'ticketing-system.Choose File'|translate | translateKey}}">
                     <span aria-hidden="true">{{'ticketing-system.Choose File'|translate | translateKey}}</span>
                     <input #fileSelect type="file" id="attachFile" ng2FileSelect [uploader]="uploader" [disabled]="attachmentsLength==5"
                     (change)="validateMessageAttachments()"  role="file" aria-label="browse" style="display: none;" multiple>
                     </label>
                 </div>
                 <div class="col-xs-12 col-md-4 pt-20">
                  <div class="floating-input col-md-8">
                      <select class="form-control" formControlName="statusId">
                          <option value="">--{{'ticketing-system.Status' |translate | translateKey}}--</option>
                          <option *ngFor="let status of statuses" [value]="status.id">{{status.value}}</option>
                      </select>
                      <div class="alert-msg" *ngIf="!draftEmailTicketForm.controls['statusId'].valid && draftEmailTicketForm.controls['statusId'].hasError('required') &&(draftEmailTicketForm.controls['statusId'].touched|| isSubmitted)">
                          {{'validation-message.Required'|translate | translateKey}}
                      </div>
					  <div class="floating-input pt-10"  *ngIf="showAssignCheckbox">
                  
                   <input float-label tabindex="1" [attr.disabled]="isNotEligibleDept == true ?'disabled': null" formControlName="assignedToMyself" type="checkbox"/>{{'ticketing-system.assign ticket to me' |translate |translateKey}}
                      </div>
                  </div>
                </div>
                 
            </div>
            <div class="row-sameheight-block">
             <span class="col-xs-12 validation-msg" *ngIf="showEmailErrorMessage">{{message}}</span>
            </div>
          <div class="pull-right mt-10">
            <button class="btn blue-button" tabindex="0" type="submit"
              [attr.disabled]="(draftEmailTicketForm.valid) ?null:''">Send
            </button>
            <button class="btn grey-button" tabindex="0" type="button" (click)="closePopUpforDraftEmailChange()">Cancel
            </button>
          </div>
        </form>
      </div>
    </modal-content>
  </modal>
  <modal #spamTicketConfirmationModal>
    <modal-header>
        <h4 class="color-blue">{{'ticketing-system.Confirmation' |translate}}</h4>      
    </modal-header>
    <modal-content >
        <div class="">
          {{'ticketing-system.Are you sure you want to mark the selected ticket as spam?' | translate}}
        </div>              
    </modal-content>
    <modal-footer>
        <div class="pull-right">     
            <button class="btn blue-button" type="button" tabindex="0" (keyup.enter)="markTicketAsSpam()" (click)="markTicketAsSpam()">
                {{'ticketing-system.Confirm' |translate}}                                                                                              
            </button>
            <button class="btn blue-button" type="button" tabindex="1" (keyup.enter)="closeSpamTicketConfirmationPopup()" (click)="closeSpamTicketConfirmationPopup()">
                {{'ticketing-system.Cancel' |translate}}                                                                                              
            </button>
        </div>
    </modal-footer>
</modal>
<modal #AddNoteConfirmationModal>
  <modal-header>
      <h4 class="color-blue">{{'ticketing-system.Add Note' |translate}}</h4>      
  </modal-header>
  <modal-content *ngIf="addNotesForm">
    <div *ngIf="distributorInfo" class="notes-distributor">
      <div>
        <span class="header-font bold">{{distributorInfo | displayNameFormat}} 
        </span>
      </div>
      <div *ngIf="distributorInfo.displayName && distributorInfo.memberTypeId === memberTypeEnum.DISTRIBUTOR" class="bold">
        <span>{{distributorInfo.displayName | titlecase}}</span>
      </div>
      <div>
        <a *ngIf="(distributorInfo?.fboId || distributorInfo?.distributorId)"><i class="fa fa-copy"  [copyToClipboard]="(distributorInfo?.fboId || distributorInfo?.distributorId)"></i></a> 
        <span *ngIf="distributorInfo.fboId">{{distributorInfo.fboId |distributorIdFormat}} </span>
        <span *ngIf="!distributorInfo.fboId">{{distributorInfo.distributorId |distributorIdFormat}} </span>
        <span *ngIf="distributorInfo.level ||distributorInfo.memberType"> | </span>
        <span>{{distributorInfo.level?distributorInfo.level:distributorInfo.memberType | titlecase}}</span>
      </div>
    </div>
    <form [formGroup]="addNotesForm" class="col-xs-12 left-padding-0 searchform" novalidate (ngSubmit)="saveNotes()">
      <div class="col-md-12 floating-input floatLabelContainer">
        <textarea float-label tabindex="0" class="form-control overflow-x-hidden noMarginBottom" formControlName="notes"  id="notes" placeholder="{{'ticketing-system.Notes'|translate}}"
            rows="5" [maxlength]="maxDescriptionChars" (focus)="descriptionFocus = true"></textarea>
         <small *ngIf="!descriptionFocus" class="text-muted d-block">{{'ticketing-system.Max ||max|| characters' | translate | translateKey :
              {'max':maxDescriptionChars } }}</small>
         <small *ngIf="descriptionFocus" class="text-muted d-block">{{ 'ticketing-system.||currentLength|| of ||max|| characters' | translate | translateKey : 
             {'currentLength': addNotesForm.value.notes ? addNotesForm.value.notes.length : 0, 'max': maxDescriptionChars} }}
         </small>
        <div class="alert-msg" *ngIf="!addNotesForm.controls['notes'].valid && addNotesForm.controls['notes'].hasError('required') &&(addNotesForm.controls['notes'].touched || submitted)">
                {{'validation-message.Required'|translate}}
        </div>
      </div>
      <div class="col-xs-12 col-md-4 pt-5 paddingbot-20 pull-right">
        <select class="form-control" formControlName="statusId">
            <option value="">--{{'ticketing-system.Status' |translate | translateKey}}--</option>
            <option *ngFor="let status of statuses" [value]="status.id">{{status.value}}</option>
        </select>
        <div class="alert-msg" *ngIf="!addNotesForm.controls['statusId'].valid && addNotesForm.controls['statusId'].hasError('required') &&(addNotesForm.controls['statusId'].touched|| submitted)">
            {{'validation-message.Required'|translate | translateKey}}
        </div>
     </div>
      <div class="pull-right">
        <input float-label tabindex="1" formControlName="sendMailNotification" type="checkbox"/>{{'ticketing-system.Send mail for this update' |translate |translateKey}}
        <span class="ico-help fa fa-question-circle" title="{{'ticketing-system.By selecting this option, an update notification will be send' |translate |translateKey}}"></span>
          <button class="form-group btn blue-button" type="submit" tabindex="0">
              {{'ticketing-system.Confirm' |translate}}                                                                                              
          </button>
          <button class="btn blue-button" type="button" tabindex="1" (keyup.enter)="closeAddNoteConfirmationPopup()" (click)="closeAddNoteConfirmationPopup()">
              {{'ticketing-system.Cancel' |translate}}                                                                                              
          </button>
      </div>
    </form>      
  </modal-content>
  <!-- <modal-footer>
    
  </modal-footer> -->
</modal>
</div>
<div style="display: none;" id="ckeditor-content"></div>


// WEBPACK FOOTER //
// ./src/app/customerservice/templates/template1/views/draft-email-ticket.component.html